import gql from 'graphql-tag';

export const PLEX_QUESTION_TEMPLATE_DETAILS_FRAGMENT = gql`
  fragment plexQuestionTemplateDetails on PlexQuestionTemplate {
    id
    questionTemplateId
    text
    question {
      id
      status
      deleted
    }
  }
`;
